/**
 * ===========================
 * CONSTANT
 * ===========================
 */
export const APP_NAME = 'WeSettle Merchant';
export const DRAWER_WIDTH = 260;

/**
 * ===========================
 * ENVIRONMENT VARIABLES
 * ===========================
 */
// api endpoint (base url)
export const BASE_ENDPOINT =
  process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3334';

// api endpoint (graphql endpoint)
export const GRAPHQL_ENDPOINT =
  process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT_MERCHANT ||
  'https://dev-api.wesettle.my/graphql-merchant';

// api endpoint (graphql subscription endpoint)
export const GRAPHQL_SUBSCRIPTION_ENDPOINT =
  process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT_MERCHANT ||
  'ws://localhost:3333/graphql';

/**
 * ===========================
 * APP ROUTE
 * ===========================
 */
// default path after login
export const DEFAULT_PATH_AFTER_SIGN_IN = '/dashboard';

// default path before login
export const DEFAULT_PATH_BEFORE_SIGN_IN = '/login';

// path for login page
export const SIGN_IN_PATH = '/login';

// page not found page
export const NOT_FOUND_PATH = '/404';

// onboarding path
export const ONBOARDING_PATH = '/onboarding';

// path accessible by public
// by default, this works as a whitelist.
// everything else that is not listed here will not be accessible by the public
export const PATHS_ONLY_ALLOWED_BEFORE_AUTH = [
  SIGN_IN_PATH,
  '/register',
  '/forgot-password',
  '/reset-password/[token]',
  '/404',
  '/500',
  '/payment-link/[token]',
  '/payment-link/[token]/make'
];

// restricted path that can't be accessed if user has already signed in
export const PATHS_NOT_ALLOWED_AFTER_AUTH = [SIGN_IN_PATH];

// path for admin portal (optional)
export const PATHS_FOR_ADMIN_ONLY = ['/app'];

// config to defined path that only shows content, which has no header, footer, sidebar, etc
// NOTE: This needed to handle on frontend level
export const NO_LAYOUT_PATH = [
  SIGN_IN_PATH,
  ONBOARDING_PATH,
  '/404',
  '/500',
  '/register',
  '/forgot-password',
  '/reset-password/[token]',
  '/payment-link/[token]',
  '/payment-link/[token]/make'
];
